import { siteColors } from '@/config/color';

export const siteThemeMixin = {
	data() {
		return {
			siteTheme: siteColors
		}
	}
};